export default {
  'connections.title': 'Connections',
  'connectionGroup.title': 'Connection Groups',

  'connections.tabs.general': 'General',
  'connections.tabs.configurations': 'Configurations',

  'connections.type.azuregraph': 'Azure Graph',
  'connections.type.openai': 'OpenAI',
  'connections.type.google': 'Google',
  'connections.type.api': 'Api',
  'connections.type.database': 'Database',
  'connections.type.azuregraphsharepoint': 'Azure Graph SharePoint',
  'connections.type.ftp': 'Ftp',
  'connections.type.linkedin': 'Linkedin',
  'connections.type.whatsappbusiness': 'WhatsApp Business',
  'connections.type.sendgrid': 'SendGrid',
  'connections.type.modelcontextprotocol': 'MCP',
  'connections.type.metapages': 'Meta Pages',
  'connections.type.smtp': 'SMTP',
  'connections.type.twilio': 'Twilio',
  'connections.type.sendblue': 'Sendblue',

  'connections.sendblue.apiKeyId': 'API Key ID',

  'connections.twilio.accountSid': 'Account SID',
  'connections.twilio.apiKeySid': 'API Key SID',

  'connections.azuregraph.credentialType': 'Credential Type',
  'connections.azuregraph.credentialType.appregistration': 'App Registration',
  'connections.azuregraph.credentialType.platformoauth': 'OAuth User (Microsoft Consent)',
  'connections.azuregraph.credentialType.unspecified': 'Unspecified',
  'connections.azuregraph.userEmail': 'Connected User Email',
  'connections.azuregraph.userEmail.help':
    'It will be filled automatically after authorizing the connection with Microsoft.',
  'connections.azuregraph.userName': 'Username',
  'connections.azuregraph.password': 'Password',
  'connections.azuregraph.clientId': 'Client Id',
  'connections.azuregraph.tenantId': 'Tenant Id',
  'connections.azuregraph.secret': 'Secret',
  'connections.azuregraph.secretExpiration': 'Secret Expiration',
  'connections.azuregraph.userId': 'User ID',
  'connections.azuregraph.userDisplayName': 'User Display Name',
  'connections.azuregraph.tokenType': 'Token Type',
  'connections.azuregraph.accessToken': 'Access Token',
  'connections.azuregraph.accessTokenExpiration': 'Access Token Expiration',
  'connections.azuregraph.refreshToken': 'Refresh Token',

  'connections.openai.apiKey': 'API Key',
  'connections.openai.organizationKey': 'Organization Key',

  'connections.google.credentialType': 'Credential Type',
  'connections.google.credentialType.serviceaccount': 'Service Account',
  'connections.google.credentialType.oauthuser': 'OAuth User (Google Consent)',
  'connections.google.credentialType.unspecified': 'Unspecified',
  'connections.google.userEmail': 'Connected User Email',
  'connections.google.userEmail.help':
    'It will be filled automatically after authorizing the connection with Google.',
  'connections.google.oauthRefreshToken': 'OAuth Refresh Token',
  'connections.google.oauthAccessToken': 'OAuth Access Token',
  'connections.google.oauthAccessTokenExpirationUtc': 'OAuth Access Token Expiration (UTC)',
  'connections.google.type': 'Type',
  'connections.google.projectId': 'Project ID',
  'connections.google.privateKeyId': 'Private Key ID',
  'connections.google.privateKey': 'Private Key',
  'connections.google.clientEmail': 'Client Email',
  'connections.google.clientId': 'Client Id',
  'connections.google.authUri': 'Auth URI',
  'connections.google.tokenUri': 'Token URI',
  'connections.google.authProviderX509CertUrl': 'Auth Provider X509 Cert URL',
  'connections.google.clientX509CertUrl': 'Client X509 Cert URL',
  'connections.google.universeDomain': 'Universe Domain',

  'connections.api.method': 'Method',
  'connections.api.method.post': 'Post',
  'connections.api.method.get': 'Get',
  'connections.api.method.put': 'Put',
  'connections.api.method.delete': 'Delete',
  'connections.api.method.patch': 'Patch',
  'connections.api.authorizationType': 'Authorization Type',
  'connections.api.authorizationType.noauth': 'No Auth',
  'connections.api.authorizationType.apikeyinheader': 'API Key In Header',
  'connections.api.authorizationType.apikeyinqueryparameters': 'API Key In Query Parameters',
  'connections.api.authorizationType.bearertoken': 'Bearer Token',
  'connections.api.authorizationType.basicauth': 'Basic Auth',
  'connections.api.authorizationType.oauth': 'OAuth',
  'connections.api.authorizationType.automyonbehalfjwt': 'Automy On Behalf JWT',
  'connections.api.url': 'URL',
  'connections.api.resultContainerPropertyName': 'Field Name with Results',
  'connections.api.codePropertyName': 'Code Field Name',
  'connections.api.searchValuePropertyName': 'Search Field Name',
  'connections.api.searchParameterPropertyName': 'Search Parameter Name',
  'connections.api.displayTextPropertyName': 'Field Name to Display',
  'connections.api.keyName': 'Key Name',
  'connections.api.keyValue': 'Key Value',
  'connections.api.token': 'Token',
  'connections.api.username': 'Username',
  'connections.api.password': 'Password',
  'connections.api.oAuthConnection': 'OAuth Connection',
  'connections.api.oAuthConnectionId': 'OAuth Connection ID',
  'connections.api.oAuthTokenResponsePropertyPosition': 'OAuth Token Response Property Position',
  'connections.api.oAuthTokenResponsePropertyName': 'OAuth Token Response Property Name',
  'connections.api.oAuthJsonBody': 'OAuth Json Body',
  'connections.api.oAuthTokenSendPropertyPosition': 'OAuth Token Send Property Position',
  'connections.api.oAuthTokenSendPropertyName': 'OAuth Token Send Property Name',
  'connections.api.subjectClaim': 'Subject Claim',
  'connections.api.audienceClaim': 'Audience Claim',
  'connections.api.additionalClaims': 'Additional Claims',
  'connections.api.confidential': 'Confidential',
  'connections.api.notConfidential': 'Not Confidential',

  'connections.api.title': 'Configure API Connections',
  'connections.api.address': 'URL Address',
  'connections.api.codeField': 'Code Field Name',
  'connections.api.showField': 'Display Field Name',
  'connections.api.resultContainerPropertyName': 'Result Container Property Name',
  'connections.api.displayTextPropertyName': 'Display Text Property Name',
  'connections.api.codePropertyName': 'Code Property Name',
  'connections.api.authorizationType': 'Authorization Type',
  'connections.api.isSharedForAllInCompany': 'Shared with entire company',
  'connections.apiHeader': 'Api Header',
  'connections.apiHeader.key-exits': 'Key Exists',
  'connections.api.webApiConnectionGroup': 'Group',

  'connections.api.position.header': 'Header',
  'connections.api.position.url': 'Url',
  'connections.api.position.formdata': 'Form Data',
  'connections.api.position.bodyjson': 'Body (JSON)',
  'connections.api.position.xwwwformurlencoded': 'Form URL Encoded',
  'connections.api.position.authorization': 'Authorization',
  'connections.api.position.bodytext': 'Body (Text)',
  'connections.api.position.formfiledata': 'Form / File',

  'connections.database.databaseType': 'Type',
  'connections.database.databaseType.sqlserver': 'SQL Server',
  'connections.database.databaseType.access': 'Access',
  'connections.database.databaseType.mysql': 'MySQL',
  'connections.database.database': 'Name',
  'connections.database.host': 'Host',
  'connections.database.port': 'Port',
  'connections.database.username': 'User',
  'connections.database.password': 'Password',
  'connections.database.query': 'Query',

  'connections.azuregraphsharepoint.sharePointCompanyUrl': 'Company URL',
  'connections.azuregraphsharepoint.userName': 'Username',
  'connections.azuregraphsharepoint.password': 'Password',
  'connections.azuregraphsharepoint.clientId': 'Client Id',
  'connections.azuregraphsharepoint.clientSecret': 'Client Secret',
  'connections.azuregraphsharepoint.authorityUrl': 'Authority URL',

  'connections.ftp.transferType': 'Transfer Type',
  'connections.ftp.host': 'Host',
  'connections.ftp.userName': 'User Name',
  'connections.ftp.authenticationMode': 'Authentication Mode',
  'connections.ftp.password': 'Password',
  'connections.ftp.privateKeyFile': 'Private Key File',
  'connections.ftp.authenticationMode.password': 'Password',
  'connections.ftp.authenticationMode.privatekeyfile': 'Private Key File',

  'connections.linkedin.clientId': 'Client Id',
  'connections.linkedin.clientSecret': 'Client Secret',

  'connections.whatsappbusiness.phoneNumberId': 'Phone Number ID',
  'connections.whatsappbusiness.displayPhoneNumber': 'Display Phone Number',
  'connections.whatsappbusiness.whatsAppBusinessAccountId': 'WhatsApp Business Account ID',
  'connections.whatsappbusiness.appId': 'App ID',
  'connections.whatsappbusiness.webhookVerifyToken': 'Webhook Verify Token',
  'connections.whatsappbusiness.accessToken': 'Access Token',

  'connections.sendgrid.apiKey': 'API Key',
  'connections.sendgrid.ipPoolName': 'IP Pool Name',
  'connections.sendgrid.emails': 'Emails',
  'connections.sendgrid.webhookEventVerificationKey': 'Webhook Event Verification Key',
  'connections.sendgrid.webhookInboundParserEventVerificationKey':
    'Webhook Inbound Parser Event Verification Key',
  'connections.sendgrid.emailValidation': 'Email Validation',
  'connections.sendgrid.emailValidationApiKey': 'Email validation API key',

  'connections.modelcontextprotocol.serverName': 'Server',
  'connections.modelcontextprotocol.packageName': 'Package Name',
  'connections.modelcontextprotocol.packageVersion': 'Package Version',
  'connections.modelcontextprotocol.launchMode': 'Launch Mode',
  'connections.modelcontextprotocol.launchMode.remote': 'Remote',
  'connections.modelcontextprotocol.launchMode.localprocess': 'Local Process',
  'connections.modelcontextprotocol.endpoint': 'Endpoint',
  'connections.modelcontextprotocol.transport': 'Transport',
  'connections.modelcontextprotocol.transport.stdio': 'STDIO',
  'connections.modelcontextprotocol.transport.http': 'HTTP',
  'connections.modelcontextprotocol.localPort': 'Local Port',
  'connections.modelcontextprotocol.command': 'Command',
  'connections.modelcontextprotocol.arguments': 'Arguments',
  'connections.modelcontextprotocol.arguments.argument': 'Argument',
  'connections.modelcontextprotocol.workingDirectory': 'Working Directory',
  'connections.modelcontextprotocol.environment': 'Environment Variables',
  'connections.modelcontextprotocol.environment.variable': 'Variable',
  'connections.modelcontextprotocol.authorizationType': 'Authorization Type',
  'connections.modelcontextprotocol.authorizationType.noauth': 'No Auth',
  'connections.modelcontextprotocol.authorizationType.automyonbehalfjwt': 'Automy On Behalf Jwt',
  'connections.modelcontextprotocol.additionalAgentInstructions': 'Additional Agent Instructions',
  'connections.modelcontextprotocol.additionalAgentInstructions.edit':
    'Edit Additional Agent Instructions',
  'connections.modelcontextprotocol.additionalAgentInstructions.placeholder':
    'Enter additional instructions for the agent...',
  'connections.modelcontextprotocol.additionalAgentVectors': 'Additional Agent Vectors',

  'connections.metapages.businessAccountId': 'Business Account ID',
  'connections.metapages.appId': 'App ID',
  'connections.metapages.appSecret': 'App Secret',
  'connections.metapages.accessToken': 'Access Token',
  'connections.metapages.webhookVerifyToken': 'Webhook Verify Token',

  'connections.smtp.fromName': 'From Name',
  'connections.smtp.fromEmail': 'From Email',
  'connections.smtp.host': 'Host',
  'connections.smtp.port': 'Port',
  'connections.smtp.enableSSL': 'Enable SSL',
  'connections.smtp.username': 'Username',
  'connections.smtp.password': 'Password',

  'connections.databases.title': 'Manage Database Connections',

  'connections.text.ownerUser': 'Owner',
  'connections.text.validated': 'Validated',
  'connections.text.permissions': 'Permissions',
  'connections.text.scopes': 'Scopes',
  'connections.text.allowedOperations': 'Allowed operations',

  'connections.operations.azureGraph.calendarFindMeetingTimes': 'Calendar / Find meeting times',
  'connections.operations.azureGraph.calendarCreateMeeting': 'Calendar / Create meeting',
  'connections.operations.azureGraph.calendarDeleteMeeting': 'Calendar / Delete meeting',
  'connections.operations.azureGraph.emailGetMessage': 'Email / Get message',
  'connections.operations.azureGraph.emailSubscribeNewMessages':
    'Email / Subscribe to new messages',

  'connections.operations.google.driveUploadFile': 'Drive / Upload file',
  'connections.operations.google.driveDownloadFile': 'Drive / Download file',
  'connections.operations.google.gmailListMessages': 'Email / List messages (Gmail)',
  'connections.operations.google.gmailGetMessage': 'Email / Get message (Gmail)',
  'connections.operations.google.gmailSendMessage': 'Email / Send message (Gmail)',
  'connections.operations.google.calendarFindMeetingTimes':
    'Calendar / Find meeting times (Google Calendar)',
  'connections.operations.google.calendarCreateMeeting':
    'Calendar / Create meeting (Google Calendar)',
  'connections.operations.google.calendarDeleteMeeting':
    'Calendar / Delete meeting (Google Calendar)',
  'connections.text.server': 'Server',
  'connections.text.validateAfterSave': 'Validate',
  'connections.text.groups': 'Connection Groups',

  'connections.callback.redirecting': 'Redirecting to connections list...',
};
